<template>
  <div class="my">
    <div class="my_header">
      <van-skeleton title avatar :row="2" v-if="userInfo==''" />
      <template v-else>
        <div @click="editUser">
          <img :src="userInfo.avatarurl" alt />
          <div>
            <span>{{userInfo.nickname}}</span>
          </div>
        </div>
      <Cell center>
         <div slot="title" style="margin-bottom:10px;font-size:.36rem;font-weight:bold;">我的个人资料</div>
         <Tag slot="label" round plain @click="editUser"> 编辑个人资料 </Tag>
      </Cell> 
      </template>
    </div>
 
    <div class="my_body">
      <CellGroup v-for="(item,index) in links" :key="index">
        <Cell is-link :to="citem.to" v-for="(citem,cindex) in item" :key="cindex">
          {{citem.name}}
          <img :src="citem.src" alt slot="icon" />
        </Cell>
      </CellGroup>
    </div>
  </div>
</template>
<style lang="less" scoped>
    @import url("index.less");
</style>
<script>
import { mapGetters } from "vuex";
import { Cell, CellGroup, Popup,Tag} from "vant";
export default {
  computed: {
    ...mapGetters({
      userInfo: "getOnlyUserInfo",
    }),
  },
  data() {
    return {
      links: [
        [
            {
                'name': '我的视频',
                'src': require('assets/img/user/video.svg'),
                'to': {name: 'EntryRecord'}
            }
           
        ],
      ],
      show: false,
    };
  },
  components: {
    Cell,
    CellGroup,
    vanPopup: Popup,
    Tag
  },
  methods: {
    editUser() {
      this.$router.push({ name: "UserEdit" });
    },
    goexchange() {
      this.$router.push({ name: "index" });
    },
    goindex() {
      this.$router.push({ name: "exchange" });
    },
    receive() {
      this.$api.user.signinh5().then((res) => {
        if (res.status * 1 === 200) {
          this.show = false;
          this.getUserInfo();
          this.$toast.success("提交成功！");
        }
      });
    },
  },
};
</script>
